<template>
  <b-container fluid>
    <NavigationBar></NavigationBar>
    <b-container v-if="error_message">
      <ErrorDisplay :error_message="error_message"
    /></b-container>
    <b-container
      class="container"
      v-if="
        Array.isArray(schedules_list_for_FBO) && schedules_list_for_FBO.length
      "
    >
      <b-table
        class="text-center"
        striped
        hover
        :items="paginatedItems"
        :fields="fields"
      >
        <template #cell(cancelBooking)="data">
          <b-button
            variant="outline-danger"
            size="sm"
            @click="cancel(data)"
            :disabled="isCancelDisabled(data)"
            >取消預訂</b-button
          >
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="center"
      ></b-pagination>
    </b-container>
    <b-container
      class="text-center"
      v-if="
        Array.isArray(schedules_list_for_FBO) &&
        !schedules_list_for_FBO.length &&
        error_message == ''
      "
      ><h1>沒有預訂資料</h1></b-container
    >
  </b-container>
</template>

<script>
import NavigationBar from "./NavigationBar.vue";
import ErrorDisplay from "./ErrorDisplay.vue";
import api from "@/api";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      fields: [
        { key: "schedules_date", label: "預訂日期" },
        { key: "schedules_time", label: "預訂時間" },
        { key: "schedules_order_time", label: "落單時間" },
        { key: "schedules_room", label: "預訂房間" },
        { key: "schedules_status", label: "預訂狀態" },
        { key: "cancelBooking", label: "取消預訂" },
      ],
      schedules_list_for_FBO: [],
      error_message: "",
    };
  },
  async created() {
    this.tabId = window.name || "Unknown Tab";
    this.currentFboId =
      localStorage.getItem(`fbo_id_${this.tabId}`) || "Not Found";
    try {
      const response = await api.post("api/schedules_list_for_FBO/", {
        fbo_id: this.currentFboId,
      });
      if (response.data.status === "success") {
        this.schedules_list_for_FBO = response.data.schedules_list_for_FBO;
      } else if (response.data.status === "error") {
        this.error_message = response.data.error_message;
      }
    } catch (e) {
      this.error_Message = "網路連線錯誤";
    }
  },
  computed: {
    totalRows() {
      return this.schedules_list_for_FBO.length;
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.schedules_list_for_FBO.slice(start, end);
    },
  },
  methods: {
    ...mapActions(["getFBOData"]),
    async cancel(data) {
      try {
        try {
          const response = await api.post("api/cancel_booking/", {
            schedules_id: data.item.schedules_id,
            fbo_id: this.currentFboId,
          });

          if (response.data.status === "success") {
            const schedules_item = this.schedules_list_for_FBO.find(
              (item) => item.schedules_id == data.item.schedules_id
            );
            schedules_item.schedules_status = "已取消";
          }
          await this.getFBOData(this.currentFboId);
        } catch (e) {
          this.error_message = e.response.data.error_message;
          return;
        }
      } catch (e) {
        this.error_Message = "網路連線錯誤";
        return;
      }
    },
    isCancelDisabled(data) {
      const CANCEL_THRESHOLD_HOURS = 2;
      const currentTime = new Date();

      const timeString = data.item.schedules_time?.split("~")[0]?.trim();
      if (!timeString) {
        // console.log("Invalid schedules_time:", data.item.schedules_time);
        return true;
      }

      const [hours, minutes] = timeString.split(":");
      if (
        !hours ||
        !minutes ||
        isNaN(parseInt(hours, 10)) ||
        isNaN(parseInt(minutes, 10))
      ) {
        // console.log("Invalid time format:", timeString);
        return true;
      }

      const dateString = data.item.schedules_date;
      if (!dateString) {
        // console.log("Missing schedules_date");
        return true;
      }

      const scheduleTime = new Date(dateString);
      if (isNaN(scheduleTime.getTime())) {
        // console.log("Invalid date format:", dateString);
        return true;
      }

      scheduleTime.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);

      if (isNaN(scheduleTime.getTime())) {
        // console.log("Invalid scheduleTime after setting hours:", scheduleTime);
        return true;
      }

      // console.log("currentTime:", currentTime);
      // console.log("scheduleTime:", scheduleTime);
      // console.log("schedules_time:", data.item.schedules_time);
      // console.log("schedules_date:", data.item.schedules_date);

      if (data.item.schedules_status === "已預約") {
        const timeDifferenceInHours =
          (scheduleTime - currentTime) / (1000 * 60 * 60);
        // console.log("timeDifferenceInHours:", timeDifferenceInHours);

        return (
          timeDifferenceInHours <= CANCEL_THRESHOLD_HOURS ||
          timeDifferenceInHours < 0
        );
      }

      return true;
    },
  },
  components: {
    NavigationBar,
    ErrorDisplay,
  },
};
</script>
